import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { Button, Col, Form, Input, Row, Modal } from "antd";

import { routeLogin } from "./../../config/api";
import { authActions } from "./../../redux/actions";

import brandLogo from "../../images/logo-byponto.svg";

import "./LoginSplit.css";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSending: false,
      error: "",
      redirectToReferrer: false,
    };
  }

  onFinish = (values) => {
    this.setState({ isSending: true });

    routeLogin(
      { action: "login", ...values },
      (response) => {
        this.setState({ isSending: false });
        const { type, ...success } = response;
        this.props.doLogin(success);
      },
      (error) => {
        this.setState({ isSending: false });
        Modal.error({
          title: "Ocorreu um erro!",
          content: String(error),
        });
      }
    );
  };

  render() {
    const { referrer } =
      this.props.location.state || { referrer: { pathname: "/" } };
    const { redirectToReferrer } = this.state;

    if (redirectToReferrer) {
      return <Redirect to={referrer} />;
    }

    return (
				<div className="auth-split__left-inner">
					{/* LOGO */}
					<div className="brand">
						<img src={brandLogo} alt="Sua Marca" />
					</div>

					{/* TÍTULO / SUB */}
					<h1 className="auth-title">Acesso ao sistema</h1>
					<p className="auth-sub">
						Entre com seu e-mail e senha para continuar.
					</p>

					{/* FORM */}
					<Form
						ref={(el) => (this.form = el)}
						layout="vertical"
						scrollToFirstError
						onFinish={this.onFinish}
						className="auth-form"
					>
						<Form.Item
							name="email"
							label="E-mail"
							rules={[
								{ required: true, message: "Campo obrigatório." },
								{ type: "email", message: "Informe um e-mail válido." },
							]}
						>
							<Input
								prefix={<i className="fal fa-envelope" />}
								placeholder="seu@email.com"
								size="large"
								autoFocus
							/>
						</Form.Item>

						<Form.Item
							name="password"
							label="Senha"
							rules={[{ required: true, message: "Campo obrigatório." }]}
						>
							<Input.Password
								prefix={<i className="fal fa-lock" />}
								placeholder="••••••••"
								size="large"
							/>
						</Form.Item>

						<Row gutter={16} align="middle" className="auth-actions">
							<Col xs={14} sm={12}>
								<Link className="link-weak" to="/recovery-password">
									Esqueci minha senha
								</Link>
							</Col>
							<Col xs={10} sm={12}>
								<Button
									type="primary"
									htmlType="submit"
									size="large"
									block
									loading={this.state.isSending}
								>
									Entrar
								</Button>
							</Col>
						</Row>
					</Form>

					{/* RODAPÉ CURTO (opcional) */}
					<div className="auth-foot">© {new Date().getFullYear()} — ByPonto</div>
				</div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  doLogin: (data) => dispatch(authActions.login(data)),
});

export default connect(null, mapDispatchToProps)(Login);
